import { render, staticRenderFns } from "./CriteriaGroupsList.vue?vue&type=template&id=dd130680&scoped=true"
import script from "./CriteriaGroupsList.vue?vue&type=script&lang=ts"
export * from "./CriteriaGroupsList.vue?vue&type=script&lang=ts"
import style0 from "./CriteriaGroupsList.vue?vue&type=style&index=0&id=dd130680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd130680",
  null
  
)

export default component.exports